import { useEffect } from "react";

const MenuItem = ({anchor, children}) => {
    return (
        <li style={{margin: `0.25rem 1rem`}}>
            <a href={`#${anchor}`}>{children}</a>
        </li>
    )
}

const Menu = () => {
    useEffect(() => {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
          anchor.addEventListener('click', function (e) {
              e.preventDefault();
        
              document.querySelector(this.getAttribute('href')).scrollIntoView({
                  behavior: 'smooth'
              })
          })
        })
    }, [])

    return (
        <nav style={{position: `fixed`, top: 0, left: 0, width: `100%`, background: `#282c34`}}>
            <ul style={{display: `flex`, flexDirection: `row`, justifyContent: `center`, listStyle: `none`, padding: 0, flexWrap: `wrap`}}>
                <MenuItem anchor="header">
                    Inicio
                </MenuItem>
                <MenuItem anchor="que-es-calpecoin">
                    ¿Qué es Calpecoin?
                </MenuItem>
                <MenuItem anchor="empezar">
                    Empezar
                </MenuItem>
                <MenuItem anchor="preguntas-frecuentes">
                    Preguntas frecuentes
                </MenuItem>
                <MenuItem anchor="comunidad">
                    Comunidad
                </MenuItem>
            </ul>
        </nav>
    )
};


export default Menu